import React from 'react'
import { func, array, bool } from 'prop-types'
import { Checkbox, Spinner } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import Icon from 'Pods/Shared/Icon/Icon'
import Tooltip from 'Pods/Shared/Tooltip'

import CompetitionLevels from './Components/CompetitionLevels'
import { levelNames } from '../../constants'

function PromoteModelTagsSection({
  tags,
  tagsLoading,
  selectedTags,
  onTagSelect,
  onLevelSelect,
  onAllTagsSelect,
  getLevelCheckboxState,
  getAllTagsCheckboxState,
  limitTagCampaignsAndCostInflation = false,
  isReadOnly = false,
}) {
  const groupTagsByLevel = () => {
    const grouped = {
      5: {
        name: levelNames[5], cost: '5 credits per tag', tags: [],
      },
      4: {
        name: levelNames[4], cost: '4 credits per tag', tags: [],
      },
      3: {
        name: levelNames[3], cost: '3 credits per tag', tags: [],
      },
      2: {
        name: levelNames[2], cost: '2 credits per tag', tags: [],
      },
      1: {
        name: levelNames[1], cost: '1 credit per tag', tags: [],
      },
    }

    tags.forEach(tag => {
      if (grouped[tag.complexity]) {
        grouped[tag.complexity].tags.push(tag)
      }
    })

    return grouped
  }

  const groupedTags = groupTagsByLevel()
  const hasAvailableTags = Object.values(groupedTags).some(levelData => levelData.tags.length > 0)
  const { checked, isIndeterminate } = getAllTagsCheckboxState()

  return (
    <div className="promote-modal__section">
      <div className="promote-modal__section-header">
        <h3 className="promote-modal__section-title">Tags for promotion</h3>
        <p className="promote-modal__section-description">
          That will help your item appear at the top of search results. Keep in mind that while
          popular tags attract more traffic, they are also more competitive.
        </p>
      </div>
      <div className="promote-modal__tags-container">
        <div className="promote-modal__tags-header">
          <div className="promote-modal__tags-header-item">
            <Checkbox
              checkedColor="primary"
              id="competition-header"
              label=""
              isChecked={checked}
              isIndeterminate={isIndeterminate}
              onChange={onAllTagsSelect}
              isDisabled={!hasAvailableTags || tagsLoading || isReadOnly}
              isControlled
              className="promote-modal__competition-checkbox"
            />
            <div className="promote-modal__competition-info">
              <span className="promote-modal__competition-label">Competition</span>
              <Tooltip
                id="competition-tooltip"
                content={`Show how popular and competitive a tag is based on the performance of models using it.
                  Higher competition tags attract more traffic but cost more Boost credits to promote.`}
              >
                <Icon type={['fas', 'info-circle']} className="promote-modal__competition-icon" />
              </Tooltip>
            </div>
          </div>
          <span className="promote-modal__tags-header-label">Model tags</span>
        </div>
        {tagsLoading ? (
          <div className="promote-modal__tags-loader">
            <Spinner />
          </div>
        ) : (
          <CompetitionLevels
            groupedTags={groupedTags}
            getLevelCheckboxState={getLevelCheckboxState}
            onLevelSelect={onLevelSelect}
            selectedTags={selectedTags}
            isReadOnly={isReadOnly}
            onTagSelect={onTagSelect}
            limitTagCampaignsAndCostInflation={limitTagCampaignsAndCostInflation}
          />
        )}
      </div>
    </div>
  )
}

PromoteModelTagsSection.propTypes = {
  tags: array.isRequired,
  tagsLoading: bool.isRequired,
  selectedTags: array.isRequired,
  onTagSelect: func.isRequired,
  onLevelSelect: func.isRequired,
  onAllTagsSelect: func.isRequired,
  getLevelCheckboxState: func.isRequired,
  getAllTagsCheckboxState: func.isRequired,
  limitTagCampaignsAndCostInflation: bool,
  isReadOnly: bool,
}

export default PromoteModelTagsSection
